import React, { Suspense, lazy } from 'react';
import { Route } from 'react-router-dom';
import ApplicationSkeleton from '~/components/ApplicationSkeleton';

const AsyncDirectoryCreate = lazy(() => import('~/containers/DirectoryCreate'));

export default [
  <Route path="/documents/:directoryId/newDirectory">
    <Suspense fallback={<ApplicationSkeleton />}>
      <AsyncDirectoryCreate />
    </Suspense>
  </Route>,
];
